import LogoImg from "../img/logo.svg";
import { Image } from "@mantine/core";

export default function Logo({ size }) {
    return (<Image src={LogoImg} width={/*size === 'sm' ?*/ '70%' /*: '50%'*/} alt="Plainstage Logo" />);
}